export const subpages = [
  {
    text: 'learnMore',
    scrollTo: 'meal-management',
  },
  {
    text: 'appStore',
    links: {
      en: '#app-store-coming-soon',
      jp: '#app-store-coming-soon',
      kr: '#app-store-coming-soon',
    },
  },
  {
    text: 'googlePlay',
    links: {
      en: '#google-play-coming-soon',
      jp: '#google-play-coming-soon',
      kr: '#google-play-coming-soon',
    },
  },
  //   {
  //     text: 'Podręczniki',
  //     link: 'books',
  //     corename: 'books',
  //     image: 'books',
  //   },
  //   {
  //     text: 'Statystyki',
  //     link: 'statistics',
  //     corename: 'statistics',
  //     image: 'statistics',
  //   },
  //   {
  //     text: 'Informacje',
  //     link: 'info',
  //     corename: 'info',
  //     image: 'info',
  //   },
]
